import React from "react";

const AppAndSystem = () => {
  return (
    <section className="grid-section">
      <div className="grid-container">
        <h2>App And System is not currently available.</h2>
      </div>
    </section>
  );
};

export default AppAndSystem;
